module.exports = __webpack_public_path__ + "static/media/icon-inverted-background.c9201c34.svg";